// tslint:disable-next-line:import-blacklist
import { MicroviewMetadata } from '@tableau/microview/lib/src/MicroviewMetadata';

export const searchMetadata: MicroviewMetadata = {
  /* this format is to match the current globalVarName of search-microview
   so searchMetadata can be used for adding script tag to the URL */
  name: 'search-microview',
  distFolderName: 'search',
};
